import React from 'react'
import { EnableNotifications } from '@app/components/alerts'
import { Onboarding } from '@app/components/alerts/onboarding'
import { ModalType } from '@app/data/enums'
import { LineChart } from '@app/components/general/charts/line-chart'
import { Cancel } from '@app/components/alerts/cancel'

type ModalTypeBaseProps = {
  modalType: ModalType
  data?: any // todo: set exact types
  // cancel props
  submit?(x: any): any
  title?: string
  description?: string
}

export const GetType = ({
  modalType,
  data,
  submit,
  title,
  description,
}: ModalTypeBaseProps) => {
  switch (modalType) {
    case ModalType.alerts: {
      return <EnableNotifications />
    }
    case ModalType.cancel: {
      return <Cancel submit={submit} title={title} description={description} />
    }
    case ModalType.onboarding: {
      return <Onboarding />
    }
    case ModalType.analytics: {
      return <LineChart data={data} />
    }
    case ModalType.empty:
    default: {
      return null
    }
  }
}
